import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  useTheme,
} from "@mui/material";
import { FieldPath, FieldValues, useController } from "react-hook-form";
import { RhfInputProps } from "../RhfInputProps";
import { selectDefaultProps } from "../selectDefaultProps";
import { emptyMenuItem } from "../SelectDefaultComponents";
import { SelectionListItem } from "../SelectionListItem";

type Props = {
  options: SelectionListItem<string>[] | undefined;
  hideLabel?: boolean;
};

export const LocationGsdbSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  control,
  options,
  disabled,
  hideLabel,
  ...selectProps
}: RhfInputProps<TFieldValues, TName> & Props & SelectProps) => {
  const label = "GSDB";
  const labelId = "locationTypeGsdb-label";
  const theme = useTheme();

  const {
    field,
    fieldState: { error },
    formState: { disabled: isFormDisabled },
  } = useController({
    control,
    name,
  });

  return (
    <FormControl fullWidth size="small" disabled={isFormDisabled || disabled}>
      {!hideLabel && (
        <InputLabel id={labelId} shrink required>
          {label}
        </InputLabel>
      )}
      <Select
        {...selectDefaultProps}
        {...selectProps}
        {...field}
        labelId={labelId}
        label={!hideLabel ? label : undefined}
        notched
        disabled={disabled}
      >
        {emptyMenuItem("")}
        {options &&
          options.map((selectionItem) => (
            <MenuItem key={selectionItem.Id} value={selectionItem.Id}>
              {selectionItem.Label}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText
        sx={{
          color: theme.palette.error.main,
          position: "absolute",
          bottom: "-1.5rem",
        }}
      >
        {error?.message}
      </FormHelperText>
    </FormControl>
  );
};
